export default __webpack_public_path__ + "static/media/c-mischief.a199c7af.png";